import React from "react";
import { StyleSheet, View } from "react-native";
import { TemplateProps } from "../../types";
import { useComponent, useTemplate } from "../providers/ConfigProvider";
import { BackgroundGradient } from "../components/BackgroundGradient";
import { StrengthWorkoutBoard } from "../components/StrengthWorkoutBoard";
import { TopBar } from "../components/TopBar";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";

const makeStyles = (theme: ThemeOptions) =>
  StyleSheet.create({
    page: {
      flex: 1,
      backgroundColor: theme.background,
    },
  });

export const VerticalStrength = ({ onLoopComplete }: TemplateProps) => {
  const template = useTemplate();
  if (template !== "vertical_strength") {
    throw new Error(
      `VerticalStrength: incorrect template provided - ${template}`,
    );
  }

  const workout = useComponent("strength_workout", "strength_workout");
  if (workout === undefined) {
    throw new Error("Failed to get strength workout");
  }

  const theme = useTheme();
  const styles = makeStyles(theme);

  return (
    <View style={styles.page}>
      <BackgroundGradient background={theme.background} accent={theme.accent} />
      <TopBar orientation="portrait" />
      <StrengthWorkoutBoard
        data={workout}
        orientation="portrait"
        onLoopComplete={onLoopComplete}
      />
    </View>
  );
};
